/**
 * Converte una stringa in Title Case (Prima Lettera Maiuscola)
 * Es: "BAROLO RISERVA" → "Barolo Riserva"
 */
export const toTitleCase = (text: string): string => {
  if (!text) return text;

  return text
    .toLowerCase()
    .split(' ')
    .map(word => {
      // Parole da mantenere minuscole (articoli, preposizioni)
      const lowercase = ['di', 'da', 'del', 'della', 'dei', 'degli', 'delle', 'e', 'ed', 'o', 'a', 'in', 'su', 'per', 'con', 'tra', 'fra'];

      if (lowercase.includes(word)) {
        return word;
      }

      // Prima lettera maiuscola
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ')
    // Capitalizza sempre la prima parola
    .replace(/^./, str => str.toUpperCase());
};

/**
 * Normalizza una stringa rimuovendo spazi extra e trim
 */
export const normalizeSpaces = (text: string): string => {
  if (!text) return text;
  return text.trim().replace(/\s+/g, ' ');
};

/**
 * Normalizza un campo di testo per il salvataggio
 * Applica Title Case e rimuove spazi extra
 */
export const normalizeTextField = (text: string | undefined): string | undefined => {
  if (!text) return text;
  const normalized = normalizeSpaces(text);
  return toTitleCase(normalized);
};

/**
 * Normalizza note/descrizioni (prima lettera maiuscola, resto minuscolo)
 */
export const normalizeNotes = (text: string | undefined): string | undefined => {
  if (!text) return text;
  const normalized = normalizeSpaces(text);
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};
